import {
  VIEW_ORDER,
  FAILED_TO_FETCH_CARTS,
  FETCHING_CART_FOR_BILLING,
  SAVE_ADDRESS,
  PAY_STATUS,
  SET_CHECKOUT_HEADER_MESSAGE,
  SET_CHECKOUT_DETAIL_CONFIRMED,
  PARTNER_CONFIRMED_CHECKOUT_DETAILS,
  SET_PAYMENT_STATUS,
  IS_NOT_DELIVERABLE,
  IS_DELIVERABLE,
  SET_USER_PAYMENT_DETAILS,
  PLACING_ORDER,
} from "../types/types"
import { store } from "../../store"
import API from "../../axiosConfig/axiosConfig"
import { ENDPOINTS } from "../../constants/apiEndPoints"
import { getFormattedAPIEndPoint } from "../../utils/urlFormations"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../../components/Notification/Notifications"
import { ERROR_SOMETHING_WENT_WRONG } from "../../constants/notificationMsg"
import AxiosAPI from "axios"
import _ from "../../utils/lodashUtils"
import { FIREBASE_STATE_KEYS, FirebaseService } from "../../firebase"

export const viewOrder = (
  messageRequired = true,
  restaurantId
) => async dispatch => {
  dispatch({
    type: FETCHING_CART_FOR_BILLING,
    payload: { isLoading: true },
  })
  // const {
  //   data: { restaurantId },
  // } = store.getState().planDinner.restaurantSuggested
  const url = getFormattedAPIEndPoint(ENDPOINTS.VIEW_ORDER_ENDPOINT, {
    $restaurantId: restaurantId,
  })
  try {
    const res = await API.get(url)
    dispatch({
      type: VIEW_ORDER,
      payload: res.data,
    })
    dispatch({
      type: FETCHING_CART_FOR_BILLING,
      payload: { isLoading: false },
    })
  } catch (err) {
    dispatch({
      type: FAILED_TO_FETCH_CARTS,
    })
    ToastMessage({
      type: NOTIFICATION_TYPES.ERROR,
      message: ERROR_SOMETHING_WENT_WRONG,
    })
  }
}
export const setPlacingOrder = value => async dispatch => {
  dispatch({
    type: PLACING_ORDER,
    payload: value,
  })
}

export const makePayment = (
  reqPayloads,
  isPayingForBoth,
  isCombined = false
) => async dispatch => {
  try {
    const URL = getFormattedAPIEndPoint(ENDPOINTS.PLACE_ORDER, {
      $restaurant_id: reqPayloads[0].merchant_id,
    })

    for (const payload of reqPayloads) {
      if (_.isEmpty(payload)) {
        continue
      }
      const config = {
        headers: {
          "Guest-Token": payload.guest_token,
        },
      }

      const total = payload["total"]
      const urlWithQueryParams = `${URL}?address=${payload.address}`
      const user_id = payload.user_id
      const merchant = payload.merchant
      const order_details = [...payload.ordered_items]
      const merchant_address = payload.merchant_address
      const paidBy = payload.paidBy
      const orderCostBreakup = payload.orderCost
      const partnerUUID = _.get(payload, "partnerUUID", "")
      const addedTip = payload.addedTip
      const tip = payload.tip
      const tipValue = payload.tipValue

      delete payload.guest_token
      delete payload.user_id
      delete payload.total
      delete payload.merchant
      delete payload.ordered_items
      delete payload.merchant_address
      delete payload.paidBy
      delete payload.orderCost
      delete payload.partnerUUID
      delete payload.tip
      delete payload.addedTip
      delete payload.tipValue

      // Added tip to checkout payload
      // https://developers.delivery.com/customer-checkout/
      payload.tip = parseFloat(parseFloat(tipValue).toFixed(2))

      const isPaymentEnabled = process.env.REACT_APP_PAYMENT_ENABLED
        ? process.env.REACT_APP_PAYMENT_ENABLED === "true"
        : false
      let data = {}
      if (addedTip) {
        // Add tip to cart
        let _tipPayload = {
          restaurant_id: payload.merchant_id,
          tip: tip,
          combined_order: isCombined,
        }
        await API.put(ENDPOINTS.ADD_TIP, _tipPayload)
      }

      if (isPaymentEnabled) {
        const response = await AxiosAPI.post(
          urlWithQueryParams,
          payload,
          config
        )
        data = response.data
      } else {
        console.log("CHECKOUT PAYLOAD", urlWithQueryParams, payload, config)
        data = {
          message: [],
          delivery_points: 466,
          order_id: 30032046,
          order_hash: "052859528574e38b5aae07885f750d3143816604",
        }
      }

      // Updating Backend Database
      const _payload = {
        order_id: data["order_id"],
        combined_order: isCombined,
        total_cost: total,
        order_details: { items: order_details },
        merchant_id: payload["merchant_id"],
        merchant: merchant,
        paid_by: paidBy,
        order_cost: orderCostBreakup,
        merchant_details: {
          merchant_id: payload["merchant_id"],
          merchant: merchant,
          address: merchant_address,
        },
        partner_uuid: partnerUUID,
      }

      const res = await API.post(ENDPOINTS.SAVE_ORDER, _payload)
      await FirebaseService.write(
        data["order_id"],
        `${FirebaseService.getDefaultPath()}/${user_id}/${[
          FIREBASE_STATE_KEYS.DELIVERY_ORDER_ID,
        ]}`
      )
    }

    dispatch(setPaymentStatus("SUCCESS"))
  } catch (err) {
    // Handle combined order scenario here.
    const {
      response: { data },
    } = err
    Array.isArray(data.message) &&
      data.message.forEach(errObj => {
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: errObj.user_msg,
        })
      })
    dispatch({
      type: PLACING_ORDER,
      payload: false,
    })
    dispatch(setPaymentStatus("FAIL"))
  }
}

export const saveUserAddress = payload => async dispatch => {
  try {
    const res = await API.put(ENDPOINTS.UPDATE_USER_ADDRESS, payload)
    dispatch({
      type: SAVE_ADDRESS,
      payload: res.data,
    })
  } catch (err) {
    ToastMessage({
      type: NOTIFICATION_TYPES.ERROR,
      message: ERROR_SOMETHING_WENT_WRONG,
    })
  }
}

export const resetCheckoutStatus = () => async dispatch => {
  await dispatch({
    type: PAY_STATUS,
    payload: null,
  })
  await dispatch({
    type: SET_CHECKOUT_HEADER_MESSAGE,
    payload: null,
  })
  await dispatch({
    type: PARTNER_CONFIRMED_CHECKOUT_DETAILS,
    payload: null,
  })
  await dispatch({
    type: SET_CHECKOUT_DETAIL_CONFIRMED,
    payload: null,
  })
  await dispatch({
    type: SET_PAYMENT_STATUS,
    payload: null,
  })
}

export const setCheckoutDetailConfirmed = isConfirm => async dispatch => {
  await dispatch({
    type: SET_CHECKOUT_DETAIL_CONFIRMED,
    payload: isConfirm,
  })
}

export const setPaymentStatus = status => async dispatch => {
  await dispatch({
    type: SET_PAYMENT_STATUS,
    payload: status,
  })
}

export const checkAddressAvailability = (
  address,
  restaurantId
) => async dispatch => {
  const URL = getFormattedAPIEndPoint(ENDPOINTS.CHECK_ADDRESS_ISDELIVERABLE, {
    $address_input: address,
    $restaurantId: restaurantId,
  })
  try {
    const res = await API.get(URL, {}, true)
    dispatch({
      type: IS_DELIVERABLE,
    })
  } catch (err) {
    dispatch({
      type: IS_NOT_DELIVERABLE,
    })
  }
}

export const saveUserpaymentDetails = details => async dispatch => {
  dispatch({
    type: SET_USER_PAYMENT_DETAILS,
    payload: details,
  })
}

export const savePaymentEvent = ({
  partner1,
  partner2,
  partner1Location,
  partner2Location,
  date,
  paidBy,
  restaurantId,
}) => async dispatch => {
  const reqBody = {
    partner1: partner1,
    partner2: partner2,
    partner1_location: partner1Location,
    partner2_location: partner2Location,
    date_time: date,
    paid_by: paidBy,
    restaurant_id: restaurantId,
  }
  try {
    const res = await API.post(ENDPOINTS.SAVE_DATE_EVENT, reqBody)
  } catch (error) {
    console.error("Error in save payment event ", error)
  }
}
